import {Component, Input, OnInit} from '@angular/core';

@Component({
  selector: 'app-top-partner-registration',
  templateUrl: './registration.component.html',
  styleUrls: ['./registration.component.css']
})
export class RegistrationComponent implements OnInit {
  @Input('housing') housing;

  constructor() { }

  ngOnInit() {
  }

}
